<app-auth-pages>
    <ng-container *transloco="let t;">
        <h2 class="card-title fw-bold mb-1">{{ t('Two Step Verification (general) - Two Step Verification') }}</h2> 
        <p class="card-text mb-2">{{t('We sent a verification code to your mobile. Enter the code from the mobile in the field below (two factor page) - We sent a verification code to your mobile. Enter the code from the mobile in the field below')}}.</p>

        <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
          <div class="alert-body">
            <p>{{ error }}</p>
          </div>
        </ngb-alert>

        <form class="auth-login-form mt-2" [formGroup]="verificationForm" (ngSubmit)="verifyOTP()">
          <div class="form-group">
            <h6>{{ t('Type your 6 digit security code (general) - Type your 6 digit security code') }}</h6>
            <code-input [codeLength]="6"
                (codeCompleted)="onCodeCompleted($event)">
            </code-input>
            <div *ngIf="submitted && verificationForm.invalid" class="invalid-feedback d-block">
              <div *ngIf="verificationForm.hasError('required', 'otp')"> {{ t('Field required (form validation) - Field name is required', { fieldName: t('OTP (general) - OTP') }) }}</div>
            </div>
          </div>
          <button type="submit" [disabled]="loading" class="btn btn-primary btn-block" tabindex="4" rippleEffect>
            <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>{{ t('Verify button name (OTP Verification page) - Verify') }}
          </button>
        </form>
        <p class="text-center mt-2"><span>{{ t('Didnt get a code (OTP Verification section) - Didnt get a code') }}</span><a href="Javascript:void(0)" (click)="sendOtp()"><span>&nbsp;{{ t('Resend otp text (OTP Verification section) - Resend')}} </span></a></p>
    </ng-container>
</app-auth-pages>